'use client'

import { styled } from 'styled-components'

export const StyledDestinationSlide = styled.div<{ $position: string; $orientation: string }>`
    position: relative;
    height: 100dvh;
    aspect-ratio: ${props => props.$orientation == "horizontal" ? "16/9" : "9/16"};
    margin-inline: auto;
    padding-inline: ${({ $orientation }) => $orientation === "horizontal" ? "2.4rem" : "1rem"};

    box-sizing: border-box;

    * {
        z-index: 2;
        position: relative;
    }

    img {
        z-index: 1;
    }

    >div {
        ${({ $orientation }) => $orientation == "horizontal" ? `
            width: 50%;
        `: ''}
        margin-left: ${({ $position, $orientation }) => 
            $orientation === "horizontal" 
                ? ($position === "left" ? "0" : "auto") 
                : "0"};

        >div {
            display: flex;
            justify-content: space-between;
            background-color: rgba(255, 255, 255, 0.4);
            margin-bottom: ${({ $orientation }) => $orientation === "horizontal" ? "1.2rem" : "1rem"};
            padding: ${({ $orientation }) => $orientation === "horizontal" ? "0.25rem 0.5rem" : "0.2rem 0.5rem"};
            border-radius: 8px;

            span {
                font-weight: bold;
                font-size: ${({ $orientation }) => $orientation === "horizontal" ? "2.8rem" : "1.6rem"};
            }

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }
`

export const TitleH1 = styled.h1<{ $color: string; $shade?: string; $orientation: string }>`
    padding-top: 2rem;
    font-size: ${({ $orientation }) => $orientation === "horizontal" ? "2.6rem" : "1.8rem"};
    color: ${props => props.$color};
    ${({ $shade, $orientation }) => $shade ? ( $orientation == 'horizontal' ? `text-shadow: ${$shade} 2px 2px;` : `text-shadow: ${$shade} 1px 1px;`) : ""}
`

export const TitleH2 = styled.h1<{ $color: string; $shade?: string; $position: string; $orientation: string }>`
    display: inline-block;
    background-color: #e40227;
    margin-left: -1rem;
    padding: 0.2rem 1rem;
    margin-bottom: 1rem;
    position: relative;
    font-size: 2.2rem;
    font-size: ${({ $orientation }) => $orientation === "horizontal" ? "3.6rem" : "2.2rem"};
    ${({ $shade, $orientation }) => $shade ? ( $orientation == 'horizontal' ? `text-shadow: ${$shade} 2px 2px;` : `text-shadow: ${$shade} 1px 1px;`) : ""}

    ${({ $orientation, $position }) => $orientation == "horizontal" ? `
        margin-left: ${$position == 'left' ? "-2.4rem" : "0"};
        padding: 0.8rem 2.4rem;
        margin-bottom: 1.4rem;    
    ` : ''}

    color: ${props => props.$color};

    &:after {
        width: calc(100% - 1rem);
        bottom: -4px;
        height: 4px;

        ${({ $orientation, $position }) => $orientation == "horizontal" ? `
            width: ${$position == 'left' ? "calc(100% - 2.4rem)" : "100%"};
            margin-left: ${$position == 'left' ? "0" : "-2.4rem"};
            bottom: -0.4rem;
            height: 0.4rem;
        ` : ''}

        display: block;
        content: "";
        background-color: white;
        z-index: 1;
        position: absolute;
    }
`

export const DestinationRowDestination = styled.span<{ $color: string; $shade?: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
`

export const DestinationRowPrice = styled.span<{ $color: string; $shade?: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
`